import UserPost from "./user-post";

export default UserPost;